import MandantService from '@/account/mandant.service';

/**
 * Service class for managing logos.
 */
export default class LogoService {
  /**
   *  returns the logo url for the given mandant id
   * @param {string | string[] | number | null} mandantId
   * @return {string | null}
   */
  public findLogoByMandantId(mandantId: string | string[] | number | null): string | null {
    const logoUrl = '/content/images/';
    const { isEfm, isVerdas } = new MandantService().extractMandant(mandantId);

    if (isVerdas) {
      return logoUrl + 'VERDAS.svg';
    }
    if (isEfm) {
      return logoUrl + 'EFM_2025.svg';
    }
    //if neither efm nor verdas, return null
    return null;
  }
}
